import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SnotifyModule, SnotifyService } from 'ng-snotify';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../shared/network/interceptors/auth.interceptor';
import { MainInterceptor } from '../shared/network/interceptors/main.interceptor';
import { ErrorHandlerInterceptor } from '../shared/network/interceptors/error-handler.interceptor';
import { SharedModule } from '../shared/shared.module';
import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsLogComponent } from './bookings-log/bookings-log.component';
import { ViewModalComponent } from './dynamic-modals/view-modal/view-modal.component';

@NgModule({
    declarations: [
        BookingsLogComponent,
        ViewModalComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        SharedModule,
        BookingsRoutingModule

    ],
    exports: [
        ViewModalComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MainInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true
        },

    ]

})
export class BookingsModule { }
